import { type Highlight } from "@/types/evidences";
import { type HighlightInfo } from "./chat-ui.types";

export function highlightToHighlightInfo(highlight: Highlight): HighlightInfo {
  return {
    page: highlight.page,
    boundingRect: {
      left: highlight.min_x * 100,
      top: highlight.min_y * 100,
      width: (highlight.max_x - highlight.min_x) * 100,
      height: (highlight.max_y - highlight.min_y) * 100,
    },
  };
}

export function getUniquePages(highlights: Highlight[]): number[] {
  const pages = [...new Set(highlights.map(h => h.page + 1))];
  return pages.sort((a, b) => a - b);
}

export function formatPageNumbers(highlights: Highlight[]): string {
  const pages = getUniquePages(highlights);

  if (pages.length === 0) return "";
  if (pages.length === 1) return `p.${pages[0]}`;

  const ranges: string[] = [];
  let rangeStart = pages[0];
  let rangeEnd = pages[0];

  for (let i = 1; i < pages.length; i++) {
    if (pages[i] === rangeEnd + 1) {
      rangeEnd = pages[i];
    } else {
      ranges.push(rangeStart === rangeEnd ? `${rangeStart}` : `${rangeStart}-${rangeEnd}`);
      rangeStart = pages[i];
      rangeEnd = pages[i];
    }
  }
  ranges.push(rangeStart === rangeEnd ? `${rangeStart}` : `${rangeStart}-${rangeEnd}`);

  return `p.${ranges.join(", ")}`;
}
